/* eslint-disable no-restricted-globals */
export const API_URL = process.env.REACT_APP_API_URL || `//${location.host}`;
